import { type FC } from "react";

import { ContentHeader } from "../../../shared/components";
import { useOrganicStats } from "../../hooks";
import { SubTabHeader } from "../SubTabHeader";
import { ChartPaper } from "../shared";

import { contentHeader, retentionContainer } from "./AdditionalInsights.styles";
import { RetentionComponent } from "./RetentionComponent";

export const RetentionSection: FC = () => {
    const { loading: chartsLoading, additionalInsights } = useOrganicStats();

    return (
        <>
            <ContentHeader
                className={contentHeader}
                title="Retention"
                subtitle="Learn about how your Lens is used over time in Snapchat."
            />
            <ChartPaper className={retentionContainer} padding="0">
                <SubTabHeader
                    label="Sessions per UU"
                    statValue={additionalInsights.sessionPerUU ?? ""}
                    diffValue={additionalInsights.sessionPerUUDiffValue}
                    tooltip="The average number of sessions that a unique user has played with your Lens in Snapchat."
                    loading={chartsLoading}
                />
                <SubTabHeader
                    label="Play time per session"
                    statValue={additionalInsights.playTimePerSession ?? ""}
                    diffValue={additionalInsights.playTimePerSessionDiffValue}
                    tooltip="The average length of time spent playing with the Lens per session."
                    loading={chartsLoading}
                />
                <SubTabHeader
                    label="Play time per UU"
                    statValue={additionalInsights.playTimePerUU ?? ""}
                    diffValue={additionalInsights.playTimePerUUDiffValue}
                    tooltip="The average length of time a unique user plays with the Lens."
                    loading={chartsLoading}
                />
            </ChartPaper>
            <ChartPaper className={retentionContainer} padding="0">
                <RetentionComponent />
            </ChartPaper>
        </>
    );
};
